import { Popover } from '@lightspeed/design-system-react'
import React from 'react'
import { Button } from '@lightspeed/design-system-react/dist/components/button/Button'
import { Icon } from '@lightspeed/design-system-react/dist/components/icon/Icon'

import { useDisplayEcomCustomSurchargesRow } from './useDisplayEcumCustomSurchargesRow'

type Props = {
  closePopover: () => void
  header: string
}
export const SaleEcomCustomChargesPopover = (props: Props) => {
  const { closePopover, header } = props
  const rows = useDisplayEcomCustomSurchargesRow()

  return <CustomPopover onClose={closePopover} title={header} rows={rows} />
}

type CustomPopoverProps = {
  onClose: () => void
  title: string
  rows: CustomPopoverRowProp[]
}
const CustomPopover = (props: CustomPopoverProps) => {
  const { title, rows, onClose } = props
  if (rows.length === 0) {
    return <></>
  }

  return (
    <Popover onClose={onClose} className="sale-popover">
      <h1 className="vd-text-label">{title}</h1>
      <hr className="vd-hr vd-mb0" />
      <table className="tax-group-table">
        <tbody>
          {rows.map(row => {
            return <CustomPopoverRow key={row.id} {...row} />
          })}
        </tbody>
      </table>
    </Popover>
  )
}

export type CustomPopoverRowProp = {
  id: string
  name: string
  value: string
  button: CustomPopoverRowButton
}
type CustomPopoverRowButton = {
  isVisible: boolean
  isDisable: boolean
  label: string
  onClick: (sourceId: string) => boolean
}
const CustomPopoverRow = (props: CustomPopoverRowProp) => {
  const {
    id,
    name,
    value,
    button: { isVisible, isDisable, label, onClick },
  } = props

  return (
    <>
      <tr key={id} className="tax-group">
        <td>
          <strong>{name}</strong>
        </td>
        <td className="tax-total">{value}</td>
        <td>
          {isVisible && (
            <Button
              disabled={isDisable}
              aria-label={label}
              className="vd-btn vd-btn--icon-no"
              onClick={() => onClick(id)}
              modifier="icon"
              variant="supplementary"
            >
              <Icon icon="fa-trash" />
            </Button>
          )}
        </td>
      </tr>
    </>
  )
}
